export function useHover(ref): boolean {
  return false;
}
